<template>
  <div>
    <div>
      <AddContactToPropertyForm
        :property="this.property"
        v-if="this.toggleAddContactToPropertyForm == true"
        v-on:newuseronproperty="addNewUserOnPropertyLocally($event)"
        v-on:closeaddusertopropertyform="toggleAddContactToPropertyFormMethod()"
      />
    </div>

      <UserLeavePropertyForm
        v-if="showLeavePropertyForm == true"
        :property="this.property"
        v-on:close-leave-property-form="toggletechleavepropertyform()"
    />

    
        <viewRolePermissions
          v-if="this.viewRoleDisplay == true"
          :roleToView="this.currentUserRoleId"
          v-on:close-view-form="toggleViewRolePermissions()"
        />


    <div v-if="this.toggleAddContactToPropertyForm == false
               && this.showLeavePropertyForm == false
               && this.viewRoleDisplay == false">
      <fab
        v-if="permissions.caninviteusers == true"
        position="bottom-right"
        bg-color="#02746E"
        main-icon="person_add"
        @click.native="toggleAddContactToPropertyFormMethod()"
      ></fab>
        
      <div v-if="this.loadingContacts == true" class="loader"></div>

      <div v-if="this.loadingContacts == false">
      <div v-if="this.contactsList != undefined">

      <div v-if="this.contactsList.length == 0 ">
      <h1> you did not invite anyone to this property, </h1>
      <h2>  please click the + button to invite.</h2>
      </div>
      </div>


        <div class="search-sort-parent">
          <el-input
            placeholder="Search or filter contacts..."
            size="mini"
            v-model="search"
            class="searchbarelement"
          ></el-input>

          <el-dropdown trigger="click" @command="SortBy">
            <el-button type="primary" size="mini">
              Sort by
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="name">Name</el-dropdown-item>
              <el-dropdown-item command="email">Email</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      <div class="cards">
        <el-card
          class="mycard"
          style="margin-bottom:20px; min-width: 320px; color: rgb(89, 89, 89);"
          v-for="user in searchContacts(sortedContacts)"
          :key="user.userid"
        >
          <el-row>
            <el-col :span="12">
              <el-avatar :size="100" :src="user.imageurl"></el-avatar>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="20">
                  <h4 class="mb-0">{{ user.firstname }} {{ user.lastname }}
                  </h4>
                </el-col>
                <el-col :span="4">
                  <el-dropdown trigger="click"                      
                  v-if="(permissions.canchangeusersrole == true || 
                        permissions.canchangeusersaccessforasset == true ||
                        permissions.canremoveusers == true ||
                        user.iscurrentuser == true)"
                    >

                    <el-button v-on:click.stop type="text">
                      <i class="el-icon-s-operation"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      
                      <el-dropdown-item
                      v-if="(permissions.canchangeusersrole == true || permissions.canchangeusersaccessforasset == true) &&
                            user.iscurrentuser == false && user.isowner == false
                      "
                      >
                        <router-link
                        style="color:unset; text-decoration: none;"
                          v-if="user.userid"
                          :to="{
                            name: 'TechRestrictions',
                            params: { TechUserId: user.userid },
                            query: { propertyid: property.propertyid },
                          }"
                        >
                          <span class="btn btn-icon-only text-light">
                            <i class="fa fa-edit mt-2"></i>User Permissions
                          </span>
                        </router-link>
                      </el-dropdown-item>
                      <el-dropdown-item
                      v-if="permissions.canremoveusers == true &&
                            user.iscurrentuser == false
                            && user.isowner == false
                            "
                        @click.native="deleteUser(user.userid, user)"
                      >
                        <i class="fa fa-trash mt-2" />Remove User
                      </el-dropdown-item>

                     <el-dropdown-item 
                      v-if="user.iscurrentuser == true"
                      @click.native="toggleViewRolePermissions(user.userroleid)"           
                     >
  
                        <i class="fa fa-edit mt-2"></i>View role
                      </el-dropdown-item>

                     <el-dropdown-item
                        v-if="user.iscurrentuser == true && user.isowner == false"
                        @click.native="toggletechleavepropertyform()"
                      >
                        <i class="fa fa-trash mt-2" />Leave property
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
              <el-row>
                <p id="user-email" class="truncate-text text-sm text-muted mb-1">{{ user.email }}</p>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
        <div class="mycard"  style="min-width:320px;" />
        <div class="mycard"  style="min-width:320px;" />
        <div class="mycard"  style="min-width:320px;" />
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import AddContactToPropertyForm from "@/components/team/addContactToPropertyForm.vue";
import UserLeavePropertyForm from "@/components/team/UserLeavePropertyForm.vue";
import viewRolePermissions from "@/components/roles/viewRolePermissions.vue"
import fab from "vue-fab";

export default {
  props: {
    property: Object,
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AddContactToPropertyForm,
    UserLeavePropertyForm,
    viewRolePermissions,
    fab
  },
  data() {
    return {
      contactsList: [],
      toggleAddContactToPropertyForm: false,
      loadingContacts: false,
      search: "",
      sortmode: "",
      permissions: {
        canchangeusersaccessforasset: false,
        caninviteusers: false,
        canremoveusers: false,
        canchangeusersrole: false
      },
      showLeavePropertyForm: false,
      viewRoleDisplay: false,
      currentUserRoleId: null
    }
  },
  created() {
    this.loadingContacts = true;
    EventService.getPropertyInvitedUsers(this.property.propertyid)
      .then(response => {
        this.loadingContacts = false

        this.contactsList = response.data.signedupusers.concat(response.data.notsignedupusers);
        this.permissions = response.data.permissions;
         console.log(this.permissions)
        });
  },
  methods: {
     
     SortBy(option) {
      this.sortmode = option;
    },
    searchContacts() {
      if(this.sortedContacts != undefined){
      return this.sortedContacts.filter(contact =>
       contact.firstname.toLowerCase().includes(this.search.toLowerCase()) ||  
       contact.lastname.toLowerCase().includes(this.search.toLowerCase()));
      }
    },
    toggleAddContactToPropertyFormMethod() {
      this.toggleAddContactToPropertyForm = !this
        .toggleAddContactToPropertyForm;
    },
    addNewUserOnPropertyLocally($event) {

      // this is to make the v-if's true to show the dropdown of options after adding locally
      $event.iscurrentuser = false
      $event.isowner = false
      
      this.contactsList.push($event);
    },
    deleteUser(userid, userObject) {
      if (userObject.userid == null) {
        EventService.RemoveUserFromPropertyByEmail(
          this.property.propertyid,
          userObject.email
        ).then( () => {
            this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Contact Removed"
          });
          })
         .catch(error => {
            console.log(error);
        });
      } else {
        EventService.RemoveUserFromPropertyByUserId(
          this.property.propertyid,
          userid
        ).then( () => {
            this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Contact Removed"
          });
          })
         .catch(error => {
            console.log(error);
        });
      }
      this.$delete(
        this.contactsList,
        this.contactsList.indexOf(userObject)
      );
    },
    toggleViewRolePermissions(userRoleId){
      if(userRoleId != undefined){
        this.currentUserRoleId = userRoleId;
      }
      this.viewRoleDisplay = !this.viewRoleDisplay;
    },
    toggletechleavepropertyform() {
      this.showLeavePropertyForm = !this.showLeavePropertyForm;
    },
  },
  computed: {
        sortedContacts: function() {
      function alphabetizeByName(a, b) {
        if (a.firstname.toUpperCase() < b.firstname.toUpperCase())
          return -1;
        if (a.firstname.toUpperCase() > b.firstname.toUpperCase())
          return 1;
        return 0;
      }
      function alphabetizeByEmail(a, b) {
        if (a.email.toUpperCase() < b.email.toUpperCase())
          return -1;
        if (a.email.toUpperCase() > b.email.toUpperCase())
          return 1;
        return 0;
      }

      if (this.sortmode === "name") {
        return this.contactsList.slice().sort(alphabetizeByName);
      }
      if (this.sortmode === "email") {
        return this.contactsList.slice().sort(alphabetizeByEmail);
      }
          return this.contactsList;
        }
  }
};
</script>

<style scoped>
h1{
  text-align: center;
}
h2{
    text-align: center;
}
.search-sort-parent{
  text-align: right;
    padding-right: 2%;
    margin-bottom: 23px;
}
#user-email{
width: 100%;
margin-left: -15px;
}
.searchbarelement {
  max-width: 300px;
}

@media only screen {
  .full-on-mobile {
    min-width: 100%;
    margin-bottom: 1px;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
}
</style>
